var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-dialog',{attrs:{"value":_vm.loginDialog,"overlay-opacity":"0.8","max-width":"600px"},on:{"input":_vm.close}},[(_vm.loginDialog)?_c('iframe',{attrs:{"src":_vm.authURL}}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }